import {Action, Dispatch} from 'redux';
import {showMessage} from './index';
import {showError} from './Common';
import {ApiActionCall, ApiActionTypes} from './Api';
import {CommonActionTypes} from '../../types/actions/Common.action';
import {
  BuybackActionTypes,
  FETCH_BUYBACK,
  FETCH_BUYBACK_ERROR,
  FETCH_BUYBACK_SUCCESS,
  SAVE_BUYBACK,
  SAVE_BUYBACK_ERROR,
  SAVE_BUYBACK_SUCCESS,
} from '../../types/actions/Buyback.actions';
import {BUYBACK_URL} from '../../@crema/services/ApiConfig';
import {IBuyback} from '../../types/models/Price';
import {logger} from '../../shared/logger';

export const saveBuyback = (buyback: boolean, sellPrice?: number) => async (
  dispatch: Dispatch<ApiActionCall | CommonActionTypes | BuybackActionTypes>,
) => {
  dispatch({type: SAVE_BUYBACK});
  const onSuccess = (payload: IBuyback) => (dispatch: Dispatch<Action>) => {
    dispatch(showMessage('Successfully saved'));
    dispatch({
      type: SAVE_BUYBACK_SUCCESS,
      payload,
    });
  };
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    dispatch({type: SAVE_BUYBACK_ERROR});
    dispatch(showError(message));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: BUYBACK_URL,
      method: 'PUT',
      data: {
        buyback,
        sellPrice,
      },
      label: 'Save buyback',
      onSuccess,
      onFailure,
    },
  });
};

export const fetchBuyback = () => async (
  dispatch: Dispatch<ApiActionCall | BuybackActionTypes>,
) => {
  dispatch({type: FETCH_BUYBACK});

  const onSuccess = (payload: IBuyback) => ({
    type: FETCH_BUYBACK_SUCCESS,
    payload,
  });
  const onFailure = (message: string) => (dispatch: Dispatch<Action>) => {
    logger.error(message);
    dispatch({type: FETCH_BUYBACK_ERROR});
    dispatch(showError('Failed to fetch buyback data.'));
  };

  dispatch({
    type: ApiActionTypes.API_CALL,
    payload: {
      url: BUYBACK_URL,
      method: 'GET',
      label: 'Fetch buyback',
      onSuccess,
      onFailure,
    },
  });
};
